import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AuthLayout } from '@/layouts/auth-layout';
import { getAuthState } from '@/stores/auth.store';

export const Route = createFileRoute('/_public')({
  beforeLoad: async () => {
    const { isAuthenticated } = getAuthState();

    // If already authenticated, redirect to dashboard
    if (isAuthenticated) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
